import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { FaEyeSlash, FaEye } from 'react-icons/fa';
import FollowCategoryBtn from '../followButtons/FollowCategoryBtn';
import NavViews from '../../../stores/NavViews';

@observer(["web3Store", "eventStore", "ViewStore", "CategoriesStore", "CustomRouter", "TeamStore", "AdminStore", "UserStore", "AuthStore"])
class CategoriesFollowed extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    renderFollowedCategory(category) {
        const { CustomRouter } = this.props;
        const { router: { goTo } } = CustomRouter;

        return (
            <div className="watchlist-followed-list-content-item">
            <div style={{display: 'inline-block'}} onClick={() => goTo(NavViews.categories, { categoryId: category._id }, CustomRouter)} >
                <img style={{ filter: 'invert(100%)' }} src={category.logoUrl} width="20px"></img>
                <span>{category.title}</span></div>
                <FollowCategoryBtn smallBtn={true} categoryId={category._id} />
            </div>
        );
    }

    renderFollowedCategories() {
        const { UserStore } = this.props;
        let categoryList = [];
        for (let category of UserStore.categoriesFollowedList.values()) {
            categoryList.push(this.renderFollowedCategory(category));
        }

        return (categoryList.length > 0 ? categoryList : <h5>No Sports followed</h5>);
    }

    render() {

        return (
            <div>
                {this.renderFollowedCategories()}
            </div>
        );
    }
}

export default CategoriesFollowed;



// WEBPACK FOOTER //
// ./src/components/layoutComponents/followList/CategoriesFollowed.js